module.exports = __webpack_public_path__ + "static/media/Skin03.d0e42abc.jpeg";